import { FinancialType } from './financial-type';

export class FinancialData {
  entityFinancialDataId?: number;
  mneFinancialDataId?: number;
  financialType: FinancialType;
  taxYear: number;
  value: number;
  valueEnteredIn: number;
}
